<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<h2>Monthly Report</h2>
			</b-col>
		</div>

		<div>
			<b-card>
				<b-row>
					<b-col v-if="role==='super_admin'" md="4">
						<b-form-group :label-cols="3" id="L1" label="Company Type" label-for="pw0" horizontal>					
							<b-form-select id="pw0" value-field="id" text-field="name" v-model="model.company_type_id" :options="company_type" @input="select_company_type()"/>
						</b-form-group>
                    </b-col>
                    <b-col v-if="role==='super_admin'" md="4">
                            <b-form-group :label-cols="3" id="L2" label="Company Name" label-for="pw1" horizontal>								
								<b-form-select  id="pw1" value-field="id" text-field="name" v-model="model.company_id" :options="company_name" @input="select_company()">       
                                    <template slot="first"><option :value="null" disabled>-- select company --</option></template>
                                </b-form-select>
							</b-form-group>
                    </b-col>
               <!--      <b-col v-if="role==='super_admin'" v-show="view" md="2">
                        <b-form-group :label-cols="2" id="L3" label="" label-for="pw2" horizontal>
                            <b-button variant="primary" class="pull-left" @click="powerbi()">Get Reports</b-button>
                        </b-form-group>
                    </b-col>  -->
                    <b-col md="4">
                        <b-form-group v-if="model.report.length>0"  :label-cols="3" id="L4" label="Select Report" label-for="pw2" horizontal>
                            <b-form-select id="pw2" value-field="id" text-field="report_name" v-model="report_id" :options="model.report" @input="select_report()">
                                <template slot="first"><option :value="null" disabled>-- select report --</option></template>
                            </b-form-select>           
                        </b-form-group>
                        <b-form-group v-show="view" v-else  :label-cols="3" id="L5" label="" label-for="pw2" horizontal>
                            <p>{{ no_report }}</p>       
                        </b-form-group>
   
                    </b-col>
				</b-row>
                    
                <b-row v-if="progress">
                    <b-col v-if="load_pdf==='Loading PDF file.....'" md="12">
                        <h5 class="text-center mt-3"> <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i> {{load_pdf }}</h5>
                       <!--  <b-progress :value="uploadPercentage" :max="100" show-progress animated class="mb-3"></b-progress> -->
                    </b-col>
                    <b-col v-else md="12">
                        <h5 class="text-center mt-3" >{{load_pdf }}</h5>
                        <!-- <b-progress :value="uploadPercentage" :max="100" show-progress animated class="mb-3"></b-progress> -->
                    </b-col>
                 </b-row>   
                <b-row>
                    <b-col md="12">          
                            <div>
                                <b-embed v-if="url!==''"
                                    type="iframe"
                                    aspect="16by9"
                                    allowfullscreen
                                    frameborder="0"
                                    :src=url
                                ></b-embed>

					            <p v-else class="text-center">
						                <i class="icon fa-lg icon-puzzle"></i><br>No Reports
					            </p>
                            </div>	
                    </b-col> 
                </b-row>
			</b-card>
		</div>
	</div>
</template>

<script>
    import pwbi_service from './pwbi_service'
    import pwbi_detail from './pwbi_detail'
    import axios from 'axios'
    import {apiDomain} from '../../config'
	export default {
		name: 'OtherReport',
		created: function() {
			this.getAll()
		},
		data() {
			return {
				found           : false,
				notFoundMessage : 'Not found',
				model           : {
                    id              : null,
                    company_type_id : null,
                    company_type    : '',
                    company_id      : null,
                    company_name    : '',
                    report          : [],
				},
                loadingData     : true,
                company_type    : [],
                company_name    : [],
                role            : '',     
                url_index       : 0,
                view            : false,
                report_id       : null,
                url             : '',
                no_report       : 'No report',
                load_pdf        : 'Loading PDF file.....',
                uploadPercentage: 0,
                progress        : false
			}
		},
		methods: {
            getAll() {
                this.loadingData = true
                pwbi_service.get_company()
                    .then(data => {
                        if (data.status == 'success') { 
                            this.role           = data.role
                            this.company_type   = data.insert_data.pwbi     
                            this.loadingData    = false
                            this.found          = true    
                            if (this.role==='super_admin') {
                                this.company_name           = data.insert_data.pwbi[0].energy_companies
                                this.model.company_type_id  = 0
                            } else if (this.role==='trucking_company_admin' || this.role==='trucking_operational_manager') {
                                this.company_name           = data.insert_data.pwbi[0].trucking_companies
                                this.model.company_type_id  = 1
                                this.company_type           = 'Trucking Company'
                                this.model.company_id       = data.insert_data.pwbi[0].trucking_companies[0].id
                                this.model.company_name     = data.insert_data.pwbi[0].trucking_companies[0].name
                                this.powerbi()
                            } else if (this.role==='super_analyst' || this.role==='analyst'  || this.role==='operations_manager' || this.role =='marketing_accountant') {
                                this.company_name           = data.insert_data.pwbi[0].energy_companies
                                this.model.company_type_id  = 0
                                this.company_type           = 'Energy Company'
                                this.model.company_id       = data.insert_data.pwbi[0].energy_companies[0].id
                                this.model.company_name     = data.insert_data.pwbi[0].energy_companies[0].name
                                this.powerbi()
                            }
                        }else {
                            this.$swal(data.status, data.message, data.status)
                            this.loadingData = false
                            return
                        }  
                    })
                    .catch(error => {
                        Vue.swal('Error', 'Server not response. ' + error, 'error')
                        this.loadingData = false
                    })
            }, 
            select_company_type() {
                if (this.role =='super_admin') {   
                    this.progress = false    
                    if (this.model.company_type_id === 0) {
                        this.company_name  =  this.company_type[0].energy_companies  
                        this.model.company_id  = null
                        this.view = false
                        this.model.report  = []
                        this.url = ''
                    } else {
                        this.company_name  =  this.company_type[1].trucking_companies
                        this.model.company_id  = null
                        this.view = false
                        this.model.report  = []
                        this.url = ''
                    }	 
                }
            },
            select_company() {
                if (this.role =='super_admin') {
                    this.progress = false    
                    let companies = this.company_name
			        let company_index = companies.map(o => o.id).indexOf(this.model.company_id)
			        if (company_index > -1) {
                        this.model.company_name = companies[company_index].name
                        this.view          = false
                        this.model.report  = []
                        this.url = ''
                        this.powerbi()                     
                        this.report_id  = null
			        } else {
                        this.model.company_name = ''
			        }
                }
            },
            select_report() {
                if (this.role =='super_admin' || this.role =='super_analyst' || this.role =='analyst' || this.role =='operations_manager' || this.role =='marketing_accountant' || this.role =='trucking_company_admin' || this.role =='trucking_operational_manager') {        
                    let reports = this.model.report
			        let report_index = reports.map(o => o.id).indexOf(this.report_id)
			        if (report_index > -1) {
                        if (reports[report_index].activate_pb) {
                            this.url = reports[report_index].url
                            this.progress = false
                        } else {
                            // this.get_pdf(reports[report_index].report_name, reports[report_index].url)
                            this.uploadPercentage   = 0
                            this.progress           = true 
                            this.load_pdf           = 'Loading PDF file.....'
                            this.url                = ''
                            this.get_pdf1(reports[report_index].report_name, reports[report_index].url)                                               
                        }
                        // this.view = true
			        } else {
                        this.url = ''
			        }
                }
            },
            powerbi() {               
                pwbi_service.find(this.model)
                    .then(data => {
                        if (data.status == 'success') { 
                            this.model.report   = data.report
                            if (this.model.report.length===0) {
                                this.view          = true
                                this.no_report       = 'No report in ' + this.model.company_name + ' Company'
                            }                           
                        } else {
                            this.$swal(data.status, data.message, data.status)
                            return
                        }  
                    })
                    .catch(error => {
                        Vue.swal('Error', 'Server not response. ' + error, 'error')
                    })
            },
            base64ToBlob(base64) {
  		        const binaryString = window.atob(base64);
  		        const len = binaryString.length;
  		        const bytes = new Uint8Array(len);
  		        for (let i = 0; i < len; ++i) {
    		        bytes[i] = binaryString.charCodeAt(i);
  		        }
  		        return new Blob([bytes], { type: 'application/pdf' });
            },
            
            get_pdf1 ( report_name, pdf ) {
                let model = {
                    'company_type_id': this.model.company_type_id,
                    'company_id'     : this.model.company_id,
                    'report_name'    : report_name,
                    'pdf'            : pdf                    
                } 

			    axios.post(apiDomain + '/report/pdf/', model, { headers: {
				        'Content-Type': 'application/json',
			            'token': localStorage.getItem('access_token')
                    },
                    onUploadProgress: ( progressEvent ) => {
                        this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ))
                    }
                })
				.then((response) => {
                    let data = response.data
                    if (data.status == 'success') {
                        let pdf_file 		= data.pdf
                        if (pdf_file!=='') {
                            let url = window.URL.createObjectURL(this.base64ToBlob(pdf_file))
                            this.url = url
							setTimeout(() => window.URL.revokeObjectURL(url), 100)
						} else {
                            this.url = ''
                        }    
                        if (this.uploadPercentage>99) {
                            this.load_pdf           = 'PDF file loaded'
                        }                   
                    } else {
                        this.progress = false
                        this.$swal(data.status, data.message, data.status)
                        return
                    }  
				})
				.catch((error) => {
                    this.progress = false
                    Vue.swal('Error', 'Server not response. ' + error, 'error')
				})
		
	        },
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/powerbi/other_report.vue